import Translate01 from "@readai/icons/uui/Translate01";
import Upload01 from "@readai/icons/uui/Upload01";

import AlertCircle from "./uui/AlertCircle";
import AlertTriangle from "./uui/AlertTriangle";
import AnnotationX from "./uui/AnnotationX";
import Announcement03 from "./uui/Announcement03";
import ArrowLeft from "./uui/ArrowLeft";
import ArrowRight from "./uui/ArrowRight";
import Briefcase01 from "./uui/Briefcase01";
import Building05 from "./uui/Building05";
import Building07 from "./uui/Building07";
import Calendar from "./uui/Calendar";
import CalendarDate from "./uui/CalendarDate";
import Check from "./uui/Check";
import CheckCircle from "./uui/CheckCircle";
import ChevronDown from "./uui/ChevronDown";
import ChevronLeft from "./uui/ChevronLeft";
import ChevronRight from "./uui/ChevronRight";
import ChevronUp from "./uui/ChevronUp";
import Copy01 from "./uui/Copy01";
import Data from "./uui/Data";
import Diamond01 from "./uui/Diamond01";
import DotsGrid from "./uui/DotsGrid";
import Download01 from "./uui/Download01";
import Edit02 from "./uui/Edit02";
import Edit05 from "./uui/Edit05";
import Eye from "./uui/Eye";
import File02 from "./uui/File02";
import File03 from "./uui/File03";
import FilterLines from "./uui/FilterLines";
import Globe02 from "./uui/Globe02";
import GraduationHat02 from "./uui/GraduationHat02";
import HelpCircle from "./uui/HelpCircle";
import Image01 from "./uui/Image01";
import InfoCircle from "./uui/InfoCircle";
import IntersectSquare from "./uui/IntersectSquare";
import Lightning01 from "./uui/Lightning01";
import Link01 from "./uui/Link01";
import LinkExternal01 from "./uui/LinkExternal01";
import Lock01 from "./uui/Lock02";
import LogIn04 from "./uui/LogIn04";
import Mail02 from "./uui/Mail02";
import Maximize01 from "./uui/Maximize01";
import Menu01 from "./uui/Menu01";
import Minimize01 from "./uui/Minimize01";
import Moon01 from "./uui/Moon01";
import PlayCircle from "./uui/PlayCircle";
import Plus from "./uui/Plus";
import RefreshCcw05 from "./uui/RefreshCcw05";
import Rocket02 from "./uui/Rocket02";
import SearchMd from "./uui/SearchMd";
import Settings01 from "./uui/Settings01";
import Share06 from "./uui/Share06";
import Star01 from "./uui/Star01";
import Star06 from "./uui/Star06";
import Stars01 from "./uui/Stars01";
import Stars02 from "./uui/Stars02";
import StickerSquare from "./uui/StickerSquare";
import StopCircle from "./uui/StopCircle";
import Tag01 from "./uui/Tag01";
import Target04 from "./uui/Target04";
import Trash01 from "./uui/Trash01";
import TypeSquare from "./uui/TypeSquare";
import User01 from "./uui/User01";
import User02 from "./uui/User02";
import UserCircle from "./uui/UserCircle";
import Users03 from "./uui/Users03";
import VideoRecorder from "./uui/VideoRecorder";
import XClose from "./uui/XClose";
import Zap from "./uui/Zap";

// plans / billing
export const EnterpriseIcon = Rocket02;
export const EnterpriseEduIcon = GraduationHat02;
export const ProIcon = Star01;
export const ProEduIcon = GraduationHat02;
export const ZoomTrialIcon = Star01;
export const FreePlanIcon = UserCircle;
export const UpgradeIcon = Rocket02;

// features / products
export const AccountIcon = UserCircle;
export const CalendarIcon = Calendar;
export const CoachingIcon = Announcement03;
export const ContactsAndGroupsIcon = Users03;
export const CustomVocabularyIcon = TypeSquare;
export const EmailIcon = Mail02;
export const ForYouIcon = Stars01;
export const IntegrationIcon = IntersectSquare;
export const MeetingAssistantIcon = VideoRecorder;
export const RecommendationsIcon = Zap;
export const RecordingAndPlaybackIcon = PlayCircle;
export const MeetingInsightsIcon = Stars01;
export const ReportingIcon = File03;
export const ReportsIcon = File02;

// actions
export const BackIcon = ChevronLeft;
export const CloseIcon = XClose;
export const CollapseIcon = ChevronUp;
export const CopyIcon = Copy01;
export const DownloadIcon = Download01;
export const EditIcon = Edit02;
export const EditSecondaryIcon = Edit05;
export const ExpandIcon = ChevronDown;
export const ExternalLinkIcon = LinkExternal01;
export const FilterIcon = FilterLines;
export const ForwardIcon = ChevronRight;
export const HamburgerMenuIcon = Menu01;
export const HelpIcon = HelpCircle;
export const LinkIcon = Link01;
export const LogOutIcon = LogIn04;
export const MaximizeIcon = Maximize01;
export const MinimizeIcon = Minimize01;
export const NextIcon = ArrowRight;
export const BackArrowIcon = ArrowLeft;
export const OptOutIcon = AnnotationX;
export const PlusIcon = Plus;
export const SearchIcon = SearchMd;
export const SettingsIcon = Settings01;
export const ShareIcon = Share06;
export const StopIcon = StopCircle;
export const StopRecordingIcon = StopCircle;
export const SyncIcon = RefreshCcw05;
export const TagIcon = Tag01;
export const TrashIcon = Trash01;
export const UploadIcon = Upload01;

// alerts
export const AlertCircleIcon = AlertCircle;
export const AlertTriangleIcon = AlertTriangle;
export const CheckCircleIcon = CheckCircle;
export const InfoCircleIcon = InfoCircle;
export const UpsellIcon = Lightning01;

// misc
export const AIIcon = Star06;
export const AISearchIcon = Stars01;
export const CheckIcon = Check;
export const CrmUpdateIcon = Target04;
export const DarkModeIcon = Moon01;
export const GridIcon = DotsGrid;
export const GlobeIcon = Globe02;
export const LockIcon = Lock01;
export const NotesIcon = StickerSquare;
export const OwnerIcon = Diamond01;
export const PreviewIcon = Image01;
export const SearchAIIcon = Stars02;
export const SourcesIcon = Data;
export const TeamIcon = Briefcase01;
export const TranslateIcon = Translate01;
export const UserIcon = User01;
export const UsersIcon = Users03;
export const ViewerIcon = Eye;
export const WorkspaceIcon = Building07;

// CRM Categories
export const CloseDateIcon = CalendarDate;
export const CompaniesIcon = Building05;
export const ContactsIcon = User02;
export const DealsIcon = Target04;
